export const ApiDef_EditableTest = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map